module.exports = __webpack_public_path__ + "img/Card_heart_7.751dc46c.svg";